import React from 'react';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './PrevButton.module.css';
import { CommonButton } from '_components';


export class PrevButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Previous'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faCaretLeft}/>
            </CommonButton>
        );
    }
}

